export default "__VITE_ASSET__BADWZ2jm__"